export default {
  required(v) {
    return (!!v && !!v.trim()) || 'erforderliche Angabe';
  },
  date(v) {
    if (!v) { return true; }
    return (
      /^(\d{1,2}).(\d{1,2}).(\d{4})$/.test(v) ||
      /^(\d{4})-(\d{1,2})-(\d{1,2})$/.test(v)
    ) || 'gültiges Format: 01.01.2018 oder 2018-01-01';
  },
  datetime(v) {
    if (!v) { return true; }
    return (
      /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d$/.test(v) ||
      /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d$/.test(v)
    ) || 'gültiges Format: 2018-01-01T12:34';
  }
};
